exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".my-custom-scrollbar {\n    position: relative;\n    height: 200px;\n    overflow: auto;\n}\n.table-wrapper-scroll-y {\ndisplay: block;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/arrival-list/arrival-list.component.css
// module id = 388
// module chunks = 0